import DateHelper from '@/lib/DateHelper'
// const debug = require('debug')('OD::GlobalDirectives')

function parseDate(el, binding) {
  binding.value = 'aaa'
  const date = el.innerHTML
  el.innerHTML = DateHelper.getDateTextString(date)
}

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive('parse-date', parseDate)
  },
}

export default GlobalDirectives
